  <ng-container *ngFor="let alarm of displayedTrainAlarms">
    <!-- Train bound alarms -->
    <span
      *ngIf="!alarm.technical"
      (click)="openDetails(alarm.tabId)"
      class="alarm-icon clickable">
      <fa-icon
        [icon]="['far', 'exclamation-triangle']"
        [ngbTooltip]="alarm.tooltipText | translate"></fa-icon>
    </span>
    <!-- Technical alarms -->
    <qm-technical-alarm-item
      *ngIf="alarm.technical"
      mode="icon"
      [alarm]="alarm.originalAlarm"
      [ngbTooltip]="alarm.tooltipText | translate"
      class="alarm-icon clickable">
    </qm-technical-alarm-item>
</ng-container>